<h2>Placards</h2>
<p-table #dt *ngIf="displayResults" [value]="placardDisplayInfo"
         [globalFilterFields]="['placardNumber', 'placardType', 'placardIssueDate', 'placardExpirationDate', 'placardStatus']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="5">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Placard Number</th>
            <th>Type</th>
            <th class="w--date">Issue Date</th>
            <th class="w--date">Expiration Date</th>
            <th>Status</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.placardNumber}}</td>
            <td>{{data.placardType}}</td>
            <td>{{data.placardIssueDate | shortDate}}</td>
            <td>{{data.placardExpirationDate | shortDate}}</td>
            <td>{{data.placardStatus}}</td>
        </tr>
    </ng-template>

</p-table>
